import Vue from "vue";
import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCV2B0aoGdSE5GcWKbglVeUqklCAAyY1O4",
    libraries: "places"
  }
});
